import { memo, useContext } from 'react';
import { useContextSelector } from 'use-context-selector';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useGetJobImprovedQuery } from 'shared/legacy/hooks/useGetJobImprovedQuery';
import { CreateEnrichedVacancy } from '../CreateEnrichedVacancy/CreateEnrichedVacancy';
import { EditEnrichedVacancy } from '../EditEnrichedVacancyForm/EditEnrichedVacancy';
import { EnrichVacancyModalContext } from '../EnrichVacancyModalContext/EnrichVacancyModalContext';
import { EnrichVacancyModalState } from '../EnrichVacancyModalContext/EnrichVacancyModalContext.types';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { useStyles } from './EnrichVacancyPages.styles';

export const EnrichVacancyPages = memo(() => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const state = useContextSelector(EnrichVacancyModalContext, (s) => s.state);
  const vacancy = useContextSelector(EnrichVacancyModalContext, (s) => s.vacancy);

  const { isFetching: isLoadingJobImproved } = useGetJobImprovedQuery(vacancy?.db_id);

  return (
    <div css={classes.formContainer}>
      {[
        EnrichVacancyModalState.ChoosingCreationMethod,
        EnrichVacancyModalState.EnrichingVacancy,
        EnrichVacancyModalState.WaitingToEnrichVacancy,
      ].includes(state) && <CreateEnrichedVacancy />}

      {[EnrichVacancyModalState.EditingEnrichedVacancy].includes(state) &&
        (isLoadingJobImproved ? (
          <LoadingPage message={`${dictionary.loading}...`} />
        ) : (
          <EditEnrichedVacancy key={vacancy?.db_id} />
        ))}
    </div>
  );
});
